import {setCacheConfigurations} from 'core/cache/config'
import {PlainLocalStorageDriver, EncryptedLocalStorageDriver} from 'core/cache'
import {decrypt, encrypt, decryptParser, valueConverter} from 'core/utility/encryption'

setCacheConfigurations({
  driver: new PlainLocalStorageDriver(),

  expireAfter: 604800,

  // valueParer: decryptParser,

  // valueConverter: valueConverter,

  prefix: 'rasil-app-',

  encryption: {
    encrypt: encrypt,

    decrypt: decrypt,
  },
})
